import React from "react";
import "./Contacts.css";

const ContactsTab = () => {
  return (
    <div>
      <div className="contacts">
        <ul className="contactsList">
          <li className="contactsItem">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.linkedin.com/in/dest/"
            >
              LinkedIn
            </a>
          </li>
          <li className="contactsItem">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://github.com/destimon"
            >
              Github
            </a>
          </li>
          <li className="contactsItem">
            <a rel="noreferrer" target="_blank" href="mailto:destaom@gmail.com">
              Mail
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ContactsTab;
